export const testimonialsES = [
  // {
  //   img: 'uniandes-facultad-ciencias-sociales.svg',
  //   alt: 'Universidad de los Andes | Facultad de Ciencias Sociales',
  //   widht: 100,
  //   height: 50,
  //   author: 'Andrés Felipe Torres Andrade',
  //   subtitle: 'Líder de Mercadeo',
  //   p: [
  //     'Adapta estrategias a nuestras necesidades, optimiza procesos, ofrece soluciones y su portafolio diversificado mejora la evaluación y rendimiento de campañas.',
  //     'Su equipo, comprometido y propositivo, ha sido clave en procesos como la integración del Cider a la Facultad de Ciencias Sociales, brindando soluciones y un portafolio amplio que facilita la evaluación y diversificación de estrategias.',
  //   ],
  // },
  // {
  //   img: 'uniandes-facultad-economia.svg',
  //   alt: 'Universidad de los Andes | Facultad de Economía',
  //   widht: 100,
  //   height: 55,
  //   author: 'David Alejandro Bautista Cabrera',
  //   subtitle: 'Coordinador de Comunicaciones',
  //   p: [
  //     'Ha sido clave para posicionar nuestros programas académicos y atraer perfiles idóneos, gracias a su profundo conocimiento de nuestra oferta.',
  //     'Sus estrategias E2E han generado excelentes resultados en matrículas, con un seguimiento detallado de cada aspirante.',
  //     'Además, su equipo destaca por la colaboración, escucha activa e innovación, siempre dispuesto a trabajar mano a mano y a optimizar procesos y resultados',
  //   ],
  // },
  // {
  //   img: 'uniandes-educacion-continua.svg',
  //   alt: 'Universidad de los Andes | Educación Continua',
  //   widht: 100,
  //   height: 60,
  //   author: 'Sandra Milena Ortiz',
  //   subtitle: 'Dirección de Educación Continua',
  //   p: [
  //     'Destaco la rapidez y el profundo conocimiento del negocio, siempre adaptándose a nuestras necesidades diarias de forma eficiente y efectiva.',
  //     'Han sabido entender las necesidades específicas de la Dirección de Educación Continua y brindar una atención ajustada a nuestra operación diaria.',
  //     'Su agilidad y compromiso hacen que sean un aliado confiable para acompañar nuestros retos y proyectos.'
  //   ],
  // },
  // {
  //   img: 'uniandes-mercadeo-y-estrategia.svg',
  //   alt: 'Universidad de los Andes',
  //   widht: 120,
  //   height: 60,
  //   author: 'Laura Chaparro',
  //   subtitle: 'Dirección de Mercadeo y Estrategia',
  //   p: [
  //     'La experiencia con nuestra cuenta ha sido clave para optimizar campañas y evolucionar juntos.',
  //     'Su enfoque end to end transformó nuestra comunicación en una gestión integral del funnel, logrando resultados claros y medibles.',
  //     'Su equipo destaca por su profesionalismo, compromiso y rapidez para adaptarse a nuestras necesidades, con estrategias respaldadas por análisis profundo y entregables de alta calidad.'
  //   ],
  // },
  {
    img: 'philip-morris.svg',
    alt: 'Philip Morris',
    widht: 100,
    height: 65,
    author: 'Geisel López',
    subtitle: 'Paid & Social Media Specialist',
    p: [
      'El equipo Merge, ha sido clave en nuestro día a día. Su agilidad, conocimiento técnico y disposición para apoyar siempre que se necesita lo convierten en un aliado confiable.',
      'Desde que asumí mi rol, me brindó todo el contexto web que requería, siendo un soporte constante en temas fuera de mi área de expertise. La adaptabilidad del equipo y su manejo técnico marcan la diferencia.',
    ],
  },
  // {
  //   img: 'isil.svg',
  //   alt: 'ISIL',
  //   widht: 100,
  //   height: 60,
  //   author: 'Javier Rony Cruces Najarro',
  //   subtitle: 'Jefe de Performance Marketing',
  //   p: [
  //     'Alcanzamos un 30% más de leads y 20% más de matriculados, optimizando medios y manteniendo el CPL bajo, incluso en un contexto adverso, gracias a un enfoque data-driven que conecta marketing con metas comerciales.',
  //     'Destaco su proactividad y orden, siempre anticipándose con propuestas estratégicas y reportes detallados. Sus dashboards y la integración SEO-SEM han sido clave para optimizar resultados sin saturar audiencias ni elevar costos.',
  //   ],
  // },
  // {
  //   img: 'universidad-externado-colombia.svg',
  //   alt: 'Universidad Externado de Colombia',
  //   widht: 120,
  //   height:55,
  //   author: 'Lizdey Morales',
  //   subtitle: 'Jefe de Marketing Digital',
  //   p: [
  //     'Resalto la calidad estratégica y técnica de sus entregables, bien estructurados y alineados con nuestras metas, dominando las herramientas digitales clave.',
  //     'Su equipo aporta ideas innovadoras y datos accionables que marcan la diferencia, siempre con cercanía y compromiso. Sus entregables destacan por su calidad técnica y estratégica, totalmente alineados a nuestras metas de negocio y respaldados por un sólido manejo de herramientas digitales.',
  //   ],
  // },
  {
    img: 'kinto-share.svg',
    alt: 'Kinto Share',
    widht: 120,
    height:55,
    author: 'Sharon Muedas',
    subtitle: 'Especialista Senior',
    p: [
      'Resalto su enfoque en la innovación, siempre buscando nuevas soluciones para mejorar los resultados.',
      'Solicitamos un dashboard para obtener un perfil más detallado de nuestros clientes, y el equipo respondió con rapidez, desarrollando la herramienta de manera proactiva. Este tipo de acción demuestra su disposición para tomar la iniciativa y proporcionar soluciones que mejoren nuestra eficiencia operativa.'
    ],
  },
  {
    img: 'traxion.svg',
    alt: 'Traxión',
    widht: 120,
    height:55,
    author: 'María Eugenia Gatica',
    subtitle: 'Directora de Marketing and Growth',
    p: [
      'Sus servicios como desarrollo web y soluciones de CRM, optimizan nuestro ecosistema de marketing, brindando eficiencia y resultados.',
      'Su capacidad de adaptación, compromiso y proactividad ha sido clave para tomar decisiones informadas y optimizar métricas clave, generando un impacto tangible en el negocio.'
    ]
  }
];

export const testimonialsEN = [
  // {
  //   img: 'uniandes-facultad-ciencias-sociales.svg',
  //   alt: 'Los Andes University | Continuing Education',
  //   widht: 100,
  //   height: 50,
  //   author: 'Andrés Felipe Torres Andrade',
  //   subtitle: 'Marketing Leader',
  //   p: [
  //     'Adapts strategies to our needs, optimizes processes, provides solutions, and its diversified portfolio improves campaign evaluation and performance.',
  //     'Its committed and proactive team has been key in processes such as the integration of Cider into the Faculty of Social Sciences, providing solutions and a broad portfolio that facilitates the evaluation and diversification of strategies.',
  //   ],
  // },
  // {
  //   img: 'uniandes-facultad-economia.svg',
  //   alt: 'Los Andes University | Continuing Education',
  //   widht: 100,
  //   height: 55,
  //   author: 'David Alejandro Bautista Cabrera',
  //   subtitle: 'Communications Coordinator',
  //   p: [
  //     'It has been key in positioning our academic programs and attracting suitable profiles, thanks to its deep knowledge of our offerings.',
  //     'Its E2E strategies have generated excellent enrollment results, with detailed follow-up of each applicant.',
  //     'In addition, its team stands out for collaboration, active listening, and innovation, always willing to work hand in hand and optimize processes and results.',
  //   ],
  // },
  // {
  //   img: 'uniandes-educacion-continua.svg',
  //   alt: 'Los Andes University | Continuing Education',
  //   widht: 100,
  //   height: 70,
  //   author: 'Sandra Milena Ortiz',
  //   subtitle: 'Director of Continuing Education',
  //   p: [
  //     'I highlight the speed and deep business knowledge, always adapting efficiently and effectively to our daily needs.',
  //     'They have been able to understand the specific needs of the Continuing Education Department and provide support tailored to our daily operations.',
  //     'Their agility and commitment make them a reliable partner to accompany our challenges and projects.',
  //   ],
  // },
  // {
  //   img: 'uniandes-mercadeo-y-estrategia.svg',
  //   alt: 'Universidad de los Andes',
  //   widht: 120,
  //   height: 60,
  //   author: 'Laura Chaparro',
  //   subtitle: 'Director of Marketing and Strategy',
  //   p: [
  //     'The experience with our account has been key to optimizing campaigns and evolving together.',
  //     'Their end-to-end approach transformed our communication into comprehensive funnel management, achieving clear and measurable results.',
  //     'Their team stands out for professionalism, commitment, and agility in adapting to our needs, with strategies backed by deep analysis and high-quality deliverables.',
  //   ],
  // },
  {
    img: 'philip-morris.svg',
    alt: 'Philip Morris',
    widht: 100,
    height: 75,
    author: 'Geisel López',
    subtitle: 'Paid & Social Media Specialist',
    p: [
      'The Merge team has been crucial in our daily operations. Their agility, technical expertise, and readiness to support whenever needed make them a reliable ally.',
      'Since I took on my role, they have provided all the web context I needed, offering constant support on topics outside my area of expertise. The team’s adaptability and technical skills make a real difference.',
    ],
  },
  // {
  //   img: 'isil.svg',
  //   alt: 'ISIL',
  //   widht: 120,
  //   height: 90,
  //   author: 'Javier Rony Cruces Najarro',
  //   subtitle: 'Head of Performance Marketing',
  //   p: [
  //     'We achieved 30% more leads and 20% more enrollments, optimizing media and keeping CPL low, even in an adverse context, thanks to a data-driven approach that connects marketing with business goals.',
  //     'I highlight their proactivity and organization, always anticipating with strategic proposals and detailed reports. Their dashboards and SEO-SEM integration have been key to optimizing results without saturating audiences or increasing costs.',
  //   ]
  // },
  // {
  //   img: 'universidad-externado-colombia.svg',
  //   alt: 'Universidad Externado de Colombia',
  //   widht: 120,
  //   height:60,
  //   author: 'Lizdey Morales',
  //   subtitle: 'Head of Digital Marketing',
  //   p: [
  //     'I highlight the strategic and technical quality of their deliverables, well-structured and aligned with our goals, mastering key digital tools.',
  //     'Their team contributes innovative ideas and actionable data that make a difference, always with closeness and commitment. Their deliverables stand out for their technical and strategic quality, fully aligned with our business goals and backed by strong command of digital tools.',
  //   ]
  // },
  {
    img: 'kinto-share.svg',
    alt: 'Kinto Share',
    widht: 120,
    height:55,
    author: 'Sharon Muedas',
    subtitle: 'Senior Specialist',
    p: [
      'I highlight their focus on innovation, always seeking new solutions to improve results.',
      'We requested a dashboard to obtain a more detailed profile of our clients, and the team responded quickly, proactively developing the tool. This type of action demonstrates their willingness to take initiative and provide solutions that enhance our operational efficiency.',
    ],
  },
  {
    img: 'traxion.svg',
    alt: 'Traxión',
    widht: 120,
    height:55,
    author: 'María Eugenia Gatica',
    subtitle: 'Marketing and Growth Director',
    p: [
      'Their services, such as web development and CRM solutions, optimize our marketing ecosystem, providing efficiency and results.',
      'Their adaptability, commitment, and proactivity have been key to making informed decisions and optimizing key metrics, generating a tangible impact on the business.',
    ],
  }
];

export const generateTestimonialsLang = (testimonials) => {
  const testimonialsList = testimonials.map((t, tI) => {
    const testimonialSub = `testimonial${tI}`;
    const p = t.p.map((p, pI) => ({ [`${testimonialSub}.p${pI}`]: p }));
    const testimonial = {
      [`${testimonialSub}.author`]: t.author,
      [`${testimonialSub}.subtitle`]: t.subtitle
    };
    p.forEach((element) => {
      Object.assign(testimonial, element);
    });
    return testimonial;
  });
  const testimonialLang = {};
  testimonialsList.forEach((element) => {
    Object.assign(testimonialLang, element);
  });
  return testimonialLang;
};

export const generateTestimonialsDataStructure = (testimonials) => {
  const testimonialsList = testimonials.map((t, tI) => {
    const testimonialSub = `testimonial${tI}`;
    const p = t.p.map((p, pI) => (`${testimonialSub}.p${pI}`));
    const testimonial = {
      ...t,
      author: `${testimonialSub}.author`,
      subtitle: t.subtitle.length > 0 ? `${testimonialSub}.subtitle` : null,
      p: p
    };
    return testimonial;
  });
  return testimonialsList;
};
